import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../../libraries/auth'
import TextInput from '../../components/form/TextInput'
import Button from '../../components/form/Button'
import FormGroup from '../../components/form/FormGroup'
import ErrorMessage from '../../components/errors/ErrorMessage'
import { useI18N } from '../../../libraries/i18n/hook'
import PasswordInput from '../../components/form/PasswordInput'

const ConfirmResetPasswordForm = () => {
  const { confirmPasswordReset } = useAuth()
  const { t } = useI18N()
  const navigate = useNavigate()
  const location = useLocation()
  const username = location.state?.username

  const [confirmationCode, setConfirmationCode] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    if (password !== confirmPassword) {
      setError(t('auth.signup.passwordMismatch') || 'Passwords do not match')
      setIsLoading(false)
      return
    }

    try {
      const result = await confirmPasswordReset(username, confirmationCode, password)
      if (!result.success) {
        setError(result.error || 'Failed to reset password')
        return
      }
      navigate('/login')
    } catch (err) {
      setError(`An unexpected error occurred ${err}`)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className='w-full space-y-6'>
      {error && <ErrorMessage error={new Error(error)} />}

      <p className='text-center text-gray-600'>{t('auth.confirmResetPassword.description')}</p>

      <FormGroup>
        <TextInput
          value={confirmationCode}
          label={t('auth.resetPassword.code')}
          placeholder={t('auth.resetPassword.code')}
          name='code'
          onChange={(e) => setConfirmationCode(e.target.value)}
          required
          className='w-full border border-gray-600'
        />
      </FormGroup>

      <FormGroup>
        <PasswordInput
          value={password}
          label={t('auth.login.password')}
          placeholder={t('auth.login.password')}
          name='password'
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </FormGroup>

      <FormGroup>
        <PasswordInput
          value={confirmPassword}
          label={t('auth.signup.confirmPassword')}
          placeholder={t('auth.signup.confirmPassword')}
          name='confirmPassword'
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
      </FormGroup>

      <Button
        type='submit'
        variant='primary'
        size='md'
        loading={isLoading}
        disabled={isLoading}
        className='w-full'
      >
        {t('auth.resetPassword.confirm')}
      </Button>
    </form>
  )
}

export default ConfirmResetPasswordForm
